export default __webpack_public_path__ + "static/media/contact.154eff2b.png";